<!--
 * @description: sn管理
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="NoContractSnsSearch"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      @customerRowDblClick="customerRowDblClick"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleLeft>
        <div>SN信息列表</div>
      </template>
      <template v-slot:tabelTitleRight>
        <add-button @buttonClick="addSn"> 添加 </add-button>
      </template>
      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        ></text-field>

        <text-field
          v-model:value="conditionData.BrandId"
          labelText="品牌名称:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguBrand"
          class="condition-container-input"
          @change="handleCompid"
        ></text-field>
        
        <text-field
          ref="selectChild"
          v-model:value="conditionData.ProductId"
          labelText="产品类别:"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'" :selectChildData="selectChildData"
          class="condition-container-input"
          :selectRemoteSearchData="selectOuguNameProduct"
          @change="handleProductId"
        ></text-field>

        <text-field
          ref="selectChildMoid"
          v-model:value="conditionData.ModelNoId"
          labelText="产品型号:"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'" :selectChildData="selectChildMoid"
          class="condition-container-input"
          :selectRemoteSearchData="selectOuguNameModelSelect"
        ></text-field>

        <text-field
          v-model:value="conditionData.sn"
          labelText="SN号:"
          class="condition-container-input"
        ></text-field>
      </template>

      <template v-slot:oprator="$opData">
        <div class="style-aaa" @click="delSingleUser($opData.data)">删除</div>
        <!-- <del-border
          :useConfirm="true"
          comfirmMessage="确定删除吗？"
          comfirmOkText="确定"
          comfirmCancelText="取消"
          @buttonClick="delSingleUser($opData.data)"
        ></del-border> -->
      </template>
    </tabel-panel>
    <sn-add v-model:value="snAddFlag" @reloadData="reloadData"></sn-add>

    <pop-dialog
      id="saveBOX"
      @confirmClick="listDataSave"
      v-if="saveBOX"
      ref="getMenuList"
      :meta="popDialogList"
      detailShowType="data"
      textButtons="保存"
      @dialogClose="saveBOX = false"
    >
      <template v-slot>
        <div class="saveBox">
          <el-form
            :model="RepairDetectEdit"
            :rules="rules"
            ref="saveEdit"
            label-width="85px"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="品牌名称:" prop>
                    <el-select
                      v-model="saveEdit.Brand_Id"
                      clearable
                      placeholder="请选择"
                      @change="addProductSelect"
                      required
                      size="small"
                    >
                      <el-option
                        v-for="item in BrandData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品类型:" prop>
                    <el-select
                      v-model="saveEdit.ProCate_Id"
                      clearable
                      size="small"
                      placeholder="请选择"
                      @change="addModelSelect"
                    >
                      <el-option
                        v-for="item in ProductData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品型号:">
                    <el-select
                      v-model="saveEdit.ModelNo_Id"
                      clearable
                      size="small"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in modelData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="SN号:" prop required>
                    <el-input
                      v-model="saveEdit.SerialNoName"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <!-- 公司名称 需要-->
              <el-col :span="14">
                <text-field
                  v-model:value="saveEdit.MaintenanceId"
                  labelText="维修中心:"
                  :clearable="true"
                  type="select"
                  :selectRemoteSearchData="selectServiceName"
                  class="condition-container-input"
                ></text-field>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple">
                  <el-form-item label="合同号:" prop="AttachName">
                    <el-input
                      v-model="saveEdit.ContractName"
                      placeholder
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <text-field
                    v-model:value="saveEdit.Company_Id"
                    labelText="客户:"
                    :clearable="true"
                    type="select"
                    :selectRemoteSearchData="selectOuguName"
                    class="condition-container-input"
                  ></text-field>
                </div>
              </el-col>
              <!-- 公司名称 需要-->
              <el-col :span="14">
                <div>
                  <span> 巡检 </span>
                  <el-radio-group v-model="saveEdit.StateY">
                    <el-radio :label="true">是 </el-radio>
                    <el-radio :label="false"> 否</el-radio>
                  </el-radio-group>
                </div>

                <!-- <el-checkbox v-model="saveEdit.StateY" label="是否巡检" size="large" /> -->
              </el-col>
            </el-row>
          </el-form>
        </div>
      </template>
    </pop-dialog>
  </div>
</template>

<script>
import { ElMessageBox } from "element-plus";
import textField from "@/components/textField.vue";
import delBorder from "@/components/delBorder.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import { ServerSNEdit, ServerSNDelById } from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import snAdd from "@/pages/dialog/snAdd.vue";
import addButton from "@/components/addButton.vue";
export default {
  name: "serviceSN",
  components: {
    textField,
    delBorder,
    tabelPanel,
    popDialog,
    snAdd,
    addButton,
  },
  data() {
    return {
      snAddFlag: false,
      inputValue: "明细",
      activeName: "second",
      loadShow: false,
      saveBOX: false,
      BrandData: null,
      ProductData: null,
      modelData: null,
      rowTemplate: [
        {
          columnType: "check",
          width: "80",
        },
        {
          headerLabel: "客户",
          width: 180,
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "品牌",
          width: 80,
          dataIndex: "BrandName",
        },
        {
          headerLabel: "类型",
          sortable: true,
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          sortable: true,
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "维修中心",
          sortable: true,
          dataIndex: "MaintenanceName",
        },
        {
          headerLabel: "SN号",
          sortable: true,
          dataIndex: "SerialNoName",
        },
        {
          headerLabel: "合同号",
          sortable: true,
          dataIndex: "ContractName",
        },
        {
          headerLabel: "是否巡检",
          dataIndex: "StateY",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "原合同客户",
          sortable: true,
          dataIndex: "ConCompName",
        },
        {
          headerLabel: "操作",
          width: 60,
          slot: "oprator",
        },
      ],
      conditionData: {
        ModelNoId: null,
        compid: null,
        BrandId: null,
        ProductId: null,
        ModelNoId: null,
        sn: null,
      },
      saveEdit: {
        Id: "",
        ModelNo_Id: "",
        SerialNoName: "",
        ContractName: "",
        Company_Id: "",
        StateY: "",
      },
      selectData: [
        {
          label: "有实物快递",
          value: 63,
        },
        {
          label: "无实物快递",
          value: 64,
        },
      ],
      ModelIllData: null,
      RepairDetectEdit: {
        id: 0, //Int	维修信息id	是
        result: "", //String	实际检测结果	是
        actills: "", //String	实际症状类型	是
        noexp: "", //String	递送方式	是
      },
      rules: {
        noexp: [
          {
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        actills: [
          {
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
      },
      options: {
        compid: [],
        ProductId: [],
        ModelNoId: [],
      },
      selectChildData: null,
      selectChildMoid: null
    };
  },
  created() {
    console.log(this.$route, "routeeee11");

    const { ModelNoId } = this.$route.query;
    if (ModelNoId) {
      this.conditionData.ModelNoId = ModelNoId;
    }
    //  debugger
    console.log(this.conditionData.ModelNoId);
    this.companyAdd();
    this.getPinP();
  },
  mounted() {
    
  },
  watch: {
    saveEdit: {
      handler: function (newV, oldV) {
        this.addProductSelect();
        this.addModelSelect();
      },
    },
    $route(to) {
        if (to.query.ModelNoId) {
          this.conditionData.ModelNoId = to.query.ModelNoId
          this.reloadData()
        }
    }
  },
  methods: {
    // 获取品牌信息
    async getPinP() {
      const res = await tableApi.BrandSelect();
      if (res.code == 0) {
        const {
          data: { list },
        } = res;
        this.options.compid = list.map((item) => ({
          label: item.Name,
          value: item.id,
        }));
      }
    },
    async handleCompid(v) {
      this.$refs.selectChild.stringValue = "";
      this.$refs.selectChildMoid.stringValue = ""
      // this.conditionData.ProductId = "";
      // this.conditionData.ModelNoId = "";
      if (!v) return;
      if (v) {
        this.selectOuguNameProduct(v);
        return;
      }
      this.selectChildData = null;
      // const res = await tableApi.ProductSelect({ Bid: v });
      // if (res.code == 0) {
      //   const {
      //     data: { list },
      //   } = res;
      //   this.options.ProductId = list.map((item) => ({
      //     label: item.Name,
      //     value: item.id,
      //   }));
      // }
    },
    async handleProductId(v) {
      // this.conditionData.ModelNoId = "";
      this.$refs.selectChildMoid.stringValue = ""
      if (!v) return;
      if (v) {
        this.selectOuguNameModelSelect(v);
        return;
      }
      this.selectChildMoid = null;

      // const res = await tableApi.modelSelect({ ProductCategoryId: v });
      // if (res.code == 0) {
      //   const {
      //     data: { list },
      //   } = res;
      //   this.options.ModelNoId = list.map((item) => ({
      //     label: item.Name,
      //     value: item.id,
      //   }));
      // }
    },
    addSn() {
      this.snAddFlag = true;
    },
    // 客户数据
    async selectOuguName() {
      // 换接口
      let source = await tableApi.CompanyInfo();
      // let source = await tableApi.CompanyInfoService();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 维修中心
    async selectServiceName() {
      // 换接口
      // let source = await tableApi.CompanyInfo();
      let source = await tableApi.CompanyInfoService();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动一级数据
     * @param {*}
     * @return {*}
     */
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 二级数据
    async selectOuguNameProduct(id) {
      let source = null
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid: id });
      }
      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 三级数据
    async selectOuguNameModelSelect(id) {
      let source = null
      if (this.selectChildData == null) {
        source = await tableApi.modelSelect()
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId: id });
      }
      this.selectChildMoid = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    companyAdd() {
      // 品牌
      tableApi.BrandSelect().then((data) => {
        if (data.code == 0) {
          this.BrandData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 类型
    addProductSelect(v) {
      // 修改列表
      if (v) {
        this.saveEdit.ProCate_Id = null
        this.saveEdit.ModelNo_Id = null
      }
      
      tableApi.ProductSelect({ Bid: v }).then((data) => {
        if (data.code == 0) {
          this.ProductData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 型号
    addModelSelect(v) {
      tableApi.modelSelect({ ProductCategoryId: v }).then((data) => {
        if (data.code == 0) {
          this.modelData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    // 删除单个
    delSingleUser({ row }) {
      let { Id } = row;
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ServerSNDelById({ Id }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },

    // 产品症状类型
    addModelIllSelect(ProductCategoryId) {
      tableApi.ModelIllSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.ModelIllData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 保存api
    listDataSave({ slotData }) {
      //   this.$refs["saveEdit"].validate((valid) => {
      //     if (valid) {
      this.RepairDetectEdit.id = slotData.row.Id;
      console.log(this.saveEdit, "saveEdit");
      const {
        Id,
        ModelNo_Id,
        SerialNoName,
        ContractName,
        Company_Id,
        StateY,
        MaintenanceId,
        TableSn
      } = this.saveEdit;
      const params = {
        Id,
        ModelNo_Id,
        Name: [SerialNoName],
        ContractName,
        Company_Id: Company_Id,
        MaintenanceId,
        StateY,
        TableSn
      };
      tableApi.addSN(params).then((data) => {
        if (data.code == 0) {
          this.saveBOX = false;
          successMsg(data.message);
          this.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log("2", slotData);
    },

    customerRowDblClick(row) {
      console.log(row, "oooooo");
      const res = JSON.stringify(row);
      this.saveEdit = JSON.parse(res);
      this.saveEdit.StateY = this.saveEdit.StateY == "否" ? false : true;
      this.saveBOX = true;
      this.$nextTick(() => {
        this.$refs.getMenuList.showPopDialog({ row }, "SN编辑信息", "slot");
      });
    },
  },
  // beforeRouteUpdate(to, form, next) {
    // console.log('路由beforeRouteUpdate--', to)
    // this.id = to.query.id;
    // next();
  // },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }

    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }

  ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    overflow: auto !important;
  }

  ::v-deep .el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
  }

  .el-row {
    margin-bottom: 16px;
  }

  .saveBox {
    padding-bottom: 20px;
  }

  ::v-deep .del-button-icon {
    margin-right: 0;
  }
}

.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
